module.exports = __webpack_public_path__ + "static/construction-worker-pipe-ecce69c2b1f6f08a2d70183b123d165a.jpeg";